import type { ReactNode } from "react";

export interface FormContentProps {
  children?: ReactNode;
  subtitle?: ReactNode;
  title?: string;
}

export const FormContent = ({
  title,
  subtitle,
  children,
}: FormContentProps) => (
  <div className="form-content">
    {!!title && <h1>{title}</h1>}
    {!!subtitle && <div className="subtitle">{subtitle}</div>}
    {children}
  </div>
);
